var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"key-item"},[_c('div',{staticClass:"key-item-color",style:({ backgroundColor: item.color })}),_c('div',{staticClass:"key-item-text"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }